import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    products: [
      { label: 'Pickles', href: '#products' },
      { label: 'Deshi Ghee', href: '#products' },
      { label: 'Murrabas', href: '#products' },
      { label: 'Gift Packages', href: '#pricing' },
    ],
    company: [
      { label: 'Our Story', href: '#our-story' },
      { label: 'Why Choose Us', href: '#why-choose-us' },
      { label: 'Reviews', href: '#reviews' },
      { label: 'Recipes', href: '#recipes' },
    ],
    support: [
      { label: 'FAQ', href: '#faq' },
      { label: 'Shipping Policy', href: '/shipping-policy' },
      { label: 'Return Policy', href: '/return-policy' },
      { label: 'Contact Us', href: '/contact-us' },
    ],
  };

  return (
    <footer className="bg-foreground text-background">
      <div className="mx-auto max-w-[1200px] px-6 py-12 lg:py-16">
        <div className="grid gap-12 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="mb-4 flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary overflow-hidden">
                <AppImage
                  src="/assets/images/Grannyz_logo_wht-01-01-1766916994944.png"
                  alt="Granny'z Farm Fresh Logo"
                  width={60}
                  height={60}
                  className="h-full w-full object-contain"
                />
              </div>
              <div className="flex flex-col">
                <span className="font-heading text-xl font-bold leading-tight">
                  Granny'z Farm Fresh
                </span>
                <span className="font-accent text-xs opacity-80">
                  Taste Tradition, Choose Health
                </span>
              </div>
            </div>
            <p className="mb-6 text-sm opacity-80">
              Bringing authentic Indian traditional foods to modern families
              since 1985. Made with love, served with pride.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/grannyz.farmfresh/"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background/10 transition-colors duration-250 ease-out hover:bg-primary"
                aria-label="Facebook"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/grannyzfarmfresh"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background/10 transition-colors duration-250 ease-out hover:bg-primary"
                aria-label="Instagram"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"/>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@grannyzfarmfresh"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background/10 transition-colors duration-250 ease-out hover:bg-primary"
                aria-label="YouTube"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-heading text-lg font-bold">Products</h3>
            <ul className="space-y-2">
              {footerLinks?.products?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-sm opacity-80 transition-opacity duration-250 ease-out hover:opacity-100"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-heading text-lg font-bold">Company</h3>
            <ul className="space-y-2">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-sm opacity-80 transition-opacity duration-250 ease-out hover:opacity-100"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-heading text-lg font-bold">Support</h3>
            <ul className="space-y-2">
              {footerLinks?.support?.map((link, index) => (
                <li key={index}>
                  {link?.href?.startsWith('#') ? (
                    <a
                      href={link?.href}
                      className="text-sm opacity-80 transition-opacity duration-250 ease-out hover:opacity-100"
                    >
                      {link?.label}
                    </a>
                  ) : (
                    <Link
                      href={link?.href}
                      className="text-sm opacity-80 transition-opacity duration-250 ease-out hover:opacity-100"
                    >
                      {link?.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-background/20 pt-8">
          <div className="grid gap-6 lg:grid-cols-2">
            <div>
              <h4 className="mb-3 font-bold">Contact Information</h4>
              <div className="space-y-2 text-sm opacity-80">
                <div className="flex items-center gap-2">
                  <Icon name="MapPinIcon" size={16} />
                  <span>Taradaham Colony, Tulsipur, Varanasi, Uttar Pradesh-221010</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="PhoneIcon" size={16} />
                  <span>+91 93352 95050</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="EnvelopeIcon" size={16} />
                  <span>support@grannyzfarmfresh.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="mb-3 font-bold">Certifications</h4>
              <div className="flex flex-wrap gap-3">
                <div className="flex items-center gap-2 rounded-lg bg-background/10 px-3 py-2 text-xs">
                  <Icon name="ShieldCheckIcon" size={16} className="text-success" />
                  <span>FSSAI Certified</span>
                </div>
                <div className="flex items-center gap-2 rounded-lg bg-background/10 px-3 py-2 text-xs">
                  <Icon name="CheckBadgeIcon" size={16} className="text-success" />
                  <span>India Organic</span>
                </div>
                <div className="flex items-center gap-2 rounded-lg bg-background/10 px-3 py-2 text-xs">
                  <Icon name="SparklesIcon" size={16} className="text-primary" />
                  <span>ISO Certified</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-background/20 pt-8 text-center text-sm opacity-80">
          <p>
            &copy; {currentYear} Granny'z Farm Fresh. All rights reserved. Made
            with <Icon name="HeartIcon" size={16} className="inline text-error" /> in
            India.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;